<template>
    <div>
        <input v-if="usingIE"
               :class="cssClass"
               v-model="ieValue"
               type="text"
               :disabled="disabled"
               :required="required"
               :readonly="readonly"
               ref="timepicker"
        />
        <input
                v-else
                :class="cssClass"
                type="time"
                :disabled="disabled"
                :required="required"
                :readonly="readonly"
                v-model="localValue"
                ref="timepicker"
        />
    </div>
</template>

<script>
    import InternetExplorer from "../mixins/InternetExplorer";

    export default {
        mixins: [InternetExplorer],

        props: {
            value: {
                type: String,
                default: '',
            },
            disabled: {
                type: Boolean,
                default: false
            },
            readonly: {
                type: Boolean,
                default: false
            },
            required: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                localValue: this.value,
                format: 'HH:mm',
                ieValue: this.value,
                ieFormat: 'h:mm A'
            }
        },

        created() {
            if (this.usingIE) {
                this.loadIETimePicker(() => {
                    $(this.$refs.timepicker).timepicker({
                        timeFormat: 'h:mm p',
                        interval: 15,
                        dynamic: false,
                        dropdown: true,
                        scrollbar: true,
                        change: (time) => {
                            this.ieValue = $(this.$refs.timepicker).val();
                        }
                    });
                    $(this.$refs.timepicker).change();
                });
            }
        },

        computed: {
            cssClass() {
                let classes = 'form-control timepicker';
                if (this.invalidTime) {
                    classes = classes + ' is-invalid';
                }
                return classes;
            },
            invalidTime() {
                return (this.required || this.value) && !moment(this.value, this.format, true).isValid();
            }
        },

        watch: {
            value(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.localValue = newVal;
                }
            },
            localValue(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.$emit('input', newVal);
                }
            },
            ieValue(val) {
                this.localValue = moment(val, this.ieFormat).format(this.format);
                // console.log('IEValue: ' + this.ieValue + '  localValue: ' + this.localValue);
            }
        }
    }
</script>
